import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationConfig, ApplicationConfigService } from '@stylehaven/components';
import { isEqual } from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class ConfigGuard {
    constructor(private readonly configService: ApplicationConfigService) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const config: ApplicationConfig = route.data.config;
        return this.checkConfig(config);
    }

    private checkConfig(expectedConfig: ApplicationConfig): Observable<boolean> {
        return this.configService
            .getConfig()
            .pipe(map(applicationConfig => this.compareConfig(expectedConfig, applicationConfig)));
    }

    private compareConfig(expectedConfig: ApplicationConfig, applicationConfig: ApplicationConfig): boolean {
        const settingComparisons: boolean[] = Object.entries(expectedConfig).map(([configKey, expectedValue]) => {
            const applicationValue = applicationConfig[configKey as keyof ApplicationConfig];
            return isEqual(applicationValue, expectedValue);
        });

        return settingComparisons.every(settingComparison => settingComparison === true);
    }
}
